import ImageSettings from '../BlockComponentSettings/ImageSettings';
import LinkData from '../LinkData';
import BlockComponentValue from './BlockComponentValue';

class BlockComponentImage implements BlockComponentValue {
  settings: ImageSettings;
  value?: string;
  alt?: string;
  link?: LinkData;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockComponentImage {
  export function make(url = '', settings?: ImageSettings, alt?: string, link?: LinkData): BlockComponentImage {
    return {
      settings: settings || ImageSettings.getDefault(),
      value: url,
      alt,
      link: link || LinkData.getDefault(),
    };
  }
}

export default BlockComponentImage;
